var _tspan;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCrazySaleHoursOnly = function SvgCrazySaleHoursOnly(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 74,
    height: 26,
    viewBox: "0 0 360 144"
  }, props), /*#__PURE__*/React.createElement("text", {
    "data-name": "24 hours only! Don't Miss Out",
    style: {
      fontSize: 16,
      fill: "#333",
      fontFamily: "&quot"
    },
    transform: "translate(4.151 62.895) scale(3.181)"
  }, "24 hours only!", _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    dy: 19.2
  }, "Don't Miss Out"))));
};
export default SvgCrazySaleHoursOnly;